module.exports = __webpack_public_path__ + "static/media/AditManuf.cd690063.png";